import { createBrowserClient } from '@supabase/ssr'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabasePublishableKey = process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY

if (!supabaseUrl) {
	throw new Error('Missing NEXT_PUBLIC_SUPABASE_URL environment variable')
}

if (!supabasePublishableKey) {
	throw new Error('Missing NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY environment variable')
}

/**
 * Browser-side Supabase client.
 *
 * Usa `createBrowserClient` do `@supabase/ssr` em vez do `createClient` cru do
 * `@supabase/supabase-js`. A diferenca essencial: este client armazena a sessao
 * em **cookies** (acessivel pelo middleware SSR e RSC) em vez de `localStorage`.
 *
 * Sem isso, o login funciona no browser mas o middleware/api-client nao
 * conseguem extrair o Bearer JWT, resultando em 401 em chamadas ao NestJS.
 */
export const supabase = createBrowserClient(supabaseUrl, supabasePublishableKey)
